import { ref } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

library.add(faSpinner);

export default {
    name: 'Card',
    components: { FontAwesomeIcon },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        showOverlay: {
            type: Boolean,
            default: false,
        },
        headerLink: {
            type: String,
            required: false,
        },
        headerLinkText: {
            type: String,
            required: false
        },  
        headerText: {
            type: String,
            required: false,
        },
        imageUrl: {
            type: String,
            required: false,
        },
        imageLink: {
            type: String,
            required: false,
        },
        contentTitle: {
            type: String,
            required: false,
        },
        contentLink: {
            type: String,
            required: false,
        },
        contentBody: {
            type: String,
            required: false,
        },  
        footerText: {
            type: String,
            required: false,
        },    
        footerLink: {
            type: String,
            required: false,
        },  
        showUpdatingOverlay: {
            type: Boolean,
            default: false
        },
        updatingOverlayText: {
            type: String,
            required: false
        },
        showRibbon: {
            type: Boolean,
            default: false
        },
        course: {
            type: Boolean,
            default: false,
        }
    },
    setup() {
        let showOverLayText = ref(false);
        return {
            showOverLayText,
        }
    }
};
